module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00587.0b94d1a8.jpg";